// @flow
import type {RecentlyViewedPropertyShape} from '../components/PropertyCarousel/PropertyCarousel';

const ACTIONS = {
    PREV_PAGE: 'PREV_PAGE',
    NEXT_PAGE: 'NEXT_PAGE',
    FETCH_LISTINGS_SUCCESS: 'FETCH_LISTINGS_SUCCESS'
};

type PrevPageActiontype = 'PREV_PAGE';
type NextPageActiontype = 'NEXT_PAGE';
type FetchListingsSuccess = 'FETCH_LISTINGS_SUCCESS';

type ActionType =
    | PrevPageActiontype
    | NextPageActiontype
    | FetchListingsSuccess;

type FetchListingsSuccessAction = {
    type: ActionType,
    payload: {
        listings: RecentlyViewedPropertyShape[]
    }
};

export type Action = FetchListingsSuccessAction;

const ACTION_CREATORS = {
    prevPage() {
        return {type: ACTIONS.PREV_PAGE, payload: {}};
    },
    nextPage() {
        return {type: ACTIONS.NEXT_PAGE, payload: {}};
    },
    fetchListingsSuccess(
        listings: RecentlyViewedPropertyShape[]
    ): FetchListingsSuccessAction {
        return {
            type: ACTIONS.FETCH_LISTINGS_SUCCESS,
            payload: {
                listings
            }
        };
    }
};

export default {...ACTIONS, ...ACTION_CREATORS};
